import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import useBrowserGeolocation from 'hooks/useBrowserGeolocation';
import useUserLocationFromCoords from 'hooks/useUserLocationFromCoords';
import useWarehouseIdForZipCode from 'hooks/useWarehouseIdForZipCode';
import { DEFAULT_WAREHOUSE_ID } from 'commons/constants';
const EMPTY_LOCATION = {};

// This hook is used to get the user's location using the browser geolocation
// API. The values are returned in a standard format to allow the
// useRefreshUserLocation hook to return the best available location for the
// user.
const useLocationFromBrowser = t0 => {
  const $ = _c(15);
  const {
    skip: t1
  } = t0;
  const skip = t1 === undefined ? false : t1;
  const {
    error: coordsFromBrowserError,
    latitude: latitudeFromBrowser,
    longitude: longitudeFromBrowser,
    isLoading: isCoordsFromBrowserLoading
  } = useBrowserGeolocation(!skip);
  const enableLocationRequestForBrowser = !skip && latitudeFromBrowser && longitudeFromBrowser && !coordsFromBrowserError;
  let t2;
  if ($[0] !== enableLocationRequestForBrowser || $[1] !== latitudeFromBrowser || $[2] !== longitudeFromBrowser) {
    t2 = enableLocationRequestForBrowser ? {
      latitude: latitudeFromBrowser,
      longitude: longitudeFromBrowser
    } : undefined;
    $[0] = enableLocationRequestForBrowser;
    $[1] = latitudeFromBrowser;
    $[2] = longitudeFromBrowser;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const latAndLongForLocationRequest = t2;
  const {
    error: locationFromBrowserError,
    isLoading: isLocationLoading,
    location: locationFromBrowser
  } = useUserLocationFromCoords(latAndLongForLocationRequest);
  const isInternationalUser = !skip && !!locationFromBrowser?.country && locationFromBrowser?.country !== "United States";
  const enableWarehouseIdForBrowserLocation = enableLocationRequestForBrowser && !!locationFromBrowser?.zip && !locationFromBrowserError && !isInternationalUser;
  const {
    error: warehouseIdForBrowserLocationError,
    loading: isWarehouseIdForBrowserLocationLoading,
    warehouseId: warehouseIdForBrowserLocation
  } = useWarehouseIdForZipCode(enableWarehouseIdForBrowserLocation ? locationFromBrowser?.zip : undefined);
  const shouldUseLocation = !skip && enableWarehouseIdForBrowserLocation && !warehouseIdForBrowserLocationError;
  let t3;
  bb0: {
    if (!shouldUseLocation) {
      t3 = undefined;
      break bb0;
    }
    if (isInternationalUser) {
      t3 = EMPTY_LOCATION;
      break bb0;
    }
    const {
      city,
      country,
      state,
      stateShortName,
      zip
    } = locationFromBrowser;
    let t4;
    if ($[4] !== city || $[5] !== country || $[6] !== state || $[7] !== stateShortName || $[8] !== zip) {
      t4 = {
        city,
        country,
        state,
        stateShortName,
        zip
      };
      $[4] = city;
      $[5] = country;
      $[6] = state;
      $[7] = stateShortName;
      $[8] = zip;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    t3 = t4;
  }
  const location = t3;
  let t4;
  bb1: {
    if (!shouldUseLocation) {
      t4 = undefined;
      break bb1;
    }
    if (isInternationalUser) {
      t4 = DEFAULT_WAREHOUSE_ID;
      break bb1;
    }
    t4 = warehouseIdForBrowserLocation;
  }
  const warehouseId = t4;
  const t5 = !skip ? isCoordsFromBrowserLoading || isLocationLoading || isWarehouseIdForBrowserLocationLoading : false;
  let t6;
  if ($[10] !== location || $[11] !== shouldUseLocation || $[12] !== t5 || $[13] !== warehouseId) {
    t6 = {
      isLoading: t5,
      location,
      shouldUseLocation,
      warehouseId
    };
    $[10] = location;
    $[11] = shouldUseLocation;
    $[12] = t5;
    $[13] = warehouseId;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
export default useLocationFromBrowser;